// extracted by mini-css-extract-plugin
export default {"SliderWrapper":"Cooperation_SliderWrapper__fgecp","sliderElements":"Cooperation_sliderElements__vtQFO","logo":"Cooperation_logo__u2dk+"};